export default class ValidationError extends Error {
    constructor(public errors: string[]) {
        super("Validation error");
    }
}